function recaptchaCallBack(token) {
    const newsLetterForm = document.querySelector('.newsletter-signup-block form');
    const form = new FormData(newsLetterForm);

    return window.fetch(`/umbraco/surface/NewsletterSignupBlock/Submit`, {
        method: "post",
        body: form
    })
        .then(response => {
            if (response.headers.has("Content-Type") && response.headers.get("Content-Type").indexOf("application/json") === 0) {
                return response.json()
                    .then(model =>{
                        if (model.redirect) {
                            window.location.href = model.redirect;
                        }
                    });
            }

            return response.ok
                ? response.text()
                    .then(html => {
                        const thankYouEle = newsLetterForm.parentNode.querySelector("[data-newsletter-thank-you]");

                        if(thankYouEle !== null){
                            thankYouEle.innerHTML = html;
                        }

                        newsLetterForm.remove();
                    })
                    .then(_ => setTimeout(() => {
                        
                    }, 10))
                : Promise.reject({
                    status: response.status,
                    body: response.statusText
                });
        });
}

let siteKeyValue = '';


const newsletterSignup = (() => {
    const initBlock = (el) => {
        handleValidation(el);
    };
    
    const handleValidation = (el) => {
        const form = el.querySelector('form');
        const errorInfo = document.querySelector("[data-error-info-bar]")
        errorInfo.classList.toggle("hidden",true);
        if (form){
            const submitButton = form.querySelector('button[type="submit"]');
            submitButton.addEventListener('click', (e) => {
                e.preventDefault();
                
                const inputFields = Array.from(form.querySelectorAll('[data-input]'));
                
                inputFields.forEach(input => {
                    if(input.checkValidity()){
                        if (input.type !== "radio"){
                            input.classList.remove('validation-error-input');
                            input.nextElementSibling.classList.remove('validation-error-message');                            
                        }
                    } else {
                        if (input.type === "radio"){
                            const surroundingEle = input.closest("[data-checkbox-inputs]");                            
                            surroundingEle.querySelector("span[data-error-message]").classList.add('validation-error-message');
                        }else{
                            input.classList.add('validation-error-input');
                            input.nextElementSibling.classList.add('validation-error-message');                            
                        }                        
                    }
                });
                
                const formValid = inputFields.every(input => input.checkValidity());
                const newsLetterForm = document.querySelector('.newsletter-signup-block form');
                const formData = new FormData(newsLetterForm);
                if(formValid){
                    submitButton.disabled = true;
                    window.fetch(`/umbraco/surface/NewsletterSignupBlock/Submit`, {
                        method: "post",
                        body: formData
                    }).then(response=>{

                        const contentType = response.headers.get("content-type");
                        if (contentType && contentType.indexOf("application/json") !== -1) {
                            return response.json().then(data => {
                                errorInfo.innerHTML = data.errorMessage;
                                errorInfo.classList.toggle("hidden",false);
                                submitButton.disabled = false;
                            });
                        } else {
                            return response.text().then(text => {
                                const content = document.querySelector("[data-content]")
                                content.innerHTML = text;
                            });
                        }
                        
                    });
                }
               
                
            })
        }
    };
    
    return {
        initBlock
    };
})();

ControlBinders.register('.newsletter-signup-block', el => newsletterSignup.initBlock(el));
